import AppHeader from '../components/AppHeader';
import { CHANGELOG } from '../changelog';
import { APP_VERSION } from '../version';

export default function Changelog() {
  return (
    <div>
      <AppHeader subtitle="Novinky" />
      <div className="container" style={{ paddingTop: 24 }}>
        <div className="mb-16">
          <h1 style={{ margin: '0 0 4px' }}>Novinky a změny</h1>
          <p className="text-muted" style={{ fontSize: '0.9rem', margin: 0 }}>
            Co se v aplikaci postupně měnilo a přibývalo.
          </p>
        </div>

        {CHANGELOG.map((entry) => {
          const isCurrent = entry.version === APP_VERSION;
          return (
            <div className="card" key={entry.version}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
                <span style={{ fontWeight: 700, fontSize: '1.05rem' }}>v{entry.version}</span>
                {isCurrent && (
                  <span style={{
                    fontSize: '0.7rem', fontWeight: 700, color: 'var(--red)',
                    background: 'var(--red-light)', borderRadius: 999, padding: '2px 9px',
                  }}>aktuální verze</span>
                )}
                <span style={{ flex: 1 }} />
                <span className="text-muted" style={{ fontSize: '0.82rem' }}>{formatDate(entry.date)}</span>
              </div>
              <ul style={{ margin: 0, paddingLeft: 20, display: 'flex', flexDirection: 'column', gap: 6 }}>
                {entry.changes.map((c, i) => (
                  <li key={i} style={{ fontSize: '0.92rem', lineHeight: 1.45 }}>{c}</li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function formatDate(iso) {
  const [y, m, d] = iso.split('-');
  return `${Number(d)}. ${Number(m)}. ${y}`;
}
